import
  React, {
  useContext
} from 'react';

import
  PropTypes
from 'prop-types';

import {
  Modal
} from 'components';

import {
  ConfirmPurchase,
  InsufficientAirtime,
  PurchaseSummary
} from '.';

import {
  getStorageWithExpiry,
  handleUtagLinkEvent,
  isFeatureEnabled
} from 'helpers';

import {
  HandleOtp
} from 'hocs';

import {
  FeatureToggles,
  OtpType
} from '../../../constants';

import {
  AppContext
} from 'context';

const J4U_Views = {
  ConfirmPurchase: 'ConfirmPurchase',
  OTP: 'OTP',
  PurchaseSummary: 'PurchaseSummary',
  InsufficientAirtime: 'InsufficientAirtime'
};

export const Just4You = props => {

  const { config } = useContext(AppContext);

  const [
    state,
    setState
  ] = React.useState({
    currentView: J4U_Views.ConfirmPurchase,
    isLoading: false,
    error: null,
    msisdnMasked: '',
    popupSettings: null,
    showPopup: false,
    transactionId: ''
  });

  const mountedRef = React.useRef(true);

  React.useEffect(() => {

    return () => {
      mountedRef.current = false;
    };
  }, []);

  const requestOtp = (response) => {

    if (!mountedRef.current) {
      return;
    }

    if (!response?.ok || !response?.result) {

      setState(prevState => ({
        ...prevState,
        error: response?.result?.messages?.[0]?.message || 'A technical error has occurred.',
        currentView: J4U_Views.PurchaseSummary
      }));

      props?.refreshOffers && props.refreshOffers();
    }
  };

  const resendOtp = async (response) => {

    if (!mountedRef.current) {
      return;
    }

    if (response?.ok && response?.result) {

      handleUtagLinkEvent({
        journey_step: 'cbu: connectu: just 4 you: resent otp',
        journey_name: 'cbu: connectu: just 4 you',
        journey_type: 'just for you',
        page_section: 'just 4 you',
        customer_city: getStorageWithExpiry('Location', 'city', null),
        visitor_type: 'consumer',
        visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
        visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
      });
    }
  };

  const verifyOtp = async (response) => {

    if (!mountedRef.current) {
      return;
    }

    if (response?.ok && response?.result) {

      setState(prevState => ({
        ...prevState,
        transactionId: response.result?.orderID,
        currentView: J4U_Views.PurchaseSummary
      }));

      props.refreshOffers?.();
      return;
    }

    if ([ 422, 423 ].includes(response?.code)) {

      handleUtagLinkEvent({
        page_section: 'just 4 you',
        error_message: response?.error
      });

      return;
    }

    if (response?.code === 406) {

      setState(prevState => ({
        ...prevState,
        currentView: J4U_Views.InsufficientAirtime
      }));

      props?.refreshOffers?.();
      return;
    }

    setState(prevState => ({
      ...prevState,
      currentView: J4U_Views.PurchaseSummary,
      error: 'There was a problem activating your bundle. Please try again later or call 082 135'
    }));

    props?.refreshOffers?.();
  };

  return (

    <>
      <Modal/>

      { state.currentView === J4U_Views.ConfirmPurchase ?

        <ConfirmPurchase
          offer={props.offer}
          onClose={props.onClose}
          onConfirm={() =>
            setState(prevState => ({
              ...prevState,
              currentView: J4U_Views.OTP
            }))
          }/>

        : state.currentView === J4U_Views.OTP ?

        <HandleOtp
          otpType={OtpType.Bundles}
          onRequestOtp={response => requestOtp(response)}
          onResendOtp={response => resendOtp(response)}
          onVerifyOtp={response => verifyOtp(response)}
          onClose={props.onClose}
          vasCode={props.offer?.vasCode}
          popupSettings={state.popupSettings}
          pageName={'cbu: connectu: just 4 you: enter otp'}
          tagViewData={{
            journey_step: 'cbu: connectu: just 4 you: enter otp',
            journey_name: 'cbu: connectu: just 4 you',
            journey_type: 'just for you',
            sales_event:  'product_view',
            customer_city: getStorageWithExpiry('Location', 'city', null),
            visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
            visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', ''),
            page_section: 'just 4 you',
            visitor_type: 'consumer'
          }}/>

        : state.currentView === J4U_Views.PurchaseSummary ?

        <PurchaseSummary
          onClose={props.onClose}
          isSuccess={!state.error}
          error={state.error}
          offer={props.offer}
          transactionId={state.transactionId}/>

        : state.currentView === J4U_Views.InsufficientAirtime ?

        <InsufficientAirtime
          onClose={props.onClose}
          enableAirtimeAdvance={isFeatureEnabled(config, FeatureToggles.EnableAirtimeAdvance)}
          pageName={'cbu: connectu: just 4 you: not enough airtime'}
          tagViewData={{
            journey_step: 'connectu: just 4 you: not enough airtime',
            journey_name: 'cbu: connectu: just 4 you',
            journey_type: 'just for you',
            page_section: 'just 4 you',
            customer_city: getStorageWithExpiry('Location', 'city', null),
            visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
            visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', ''),
            visitor_type: 'consumer'
          }}/>

        : <></>
      }

    </>
  );
};

Just4You.propTypes = {
  onClose: PropTypes.func.isRequired,
  offer: PropTypes.object.isRequired,
  refreshOffers: PropTypes.func
};

Just4You.defaultProps = {
  onClose: () => {},
  offer: {},
  refreshOffers: () => {}
};
